import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { useSelector } from "react-redux"
import { useAppDispatch } from "lib/store"
import { toggleEditSidebar } from "lib/store/services/editSidebar/slice"
import { editSidebarOpen } from "lib/store/services/editSidebar/selectors"

import { ALL_EXTERNAL_PRICE_PROVIDERS } from "graphql/queries/config/AllExternalPriceProviders"

import PageHeader from "components/Ui/Page/PageHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import { CreateExternalPriceConfig } from "./CreateExternalPriceConfig"
import { ExternalPriceConfigTable } from "components/Config/ExternalPrice/ExternalPriceConfigTable"
import { EditExternalPriceConfig } from "./EditExternalPriceConfig"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { ReactComponent as ExternalPriceLogo } from "images/icons/circle-dollar.svg"
import { WithAuth } from "../../../../components/Auth"
import { PermissionGroups } from "../../../../routes/constants"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const StyledExternalPriceLogo = styled(ExternalPriceLogo)`
  height: 3.5rem;
  margin-right: 1.5rem;
`

export const ExternalPriceConfiguration = () => {
  const [externalPriceConfigId, setExternalPriceConfigId] = useState<string>("")
  const isSidebarOpen = useSelector(editSidebarOpen)
  const { loading, data, refetch, error } = useQuery(ALL_EXTERNAL_PRICE_PROVIDERS)
  const externalPriceProviders = data?.getExternalPriceConfigs
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isSidebarOpen) {
      setExternalPriceConfigId("")
    }
  }, [isSidebarOpen])

  return (
    <Container>
      <PageHeader
        title={
          <>
            <StyledExternalPriceLogo /> Custom external price providers
          </>
        }
        description="Handle your external price providers"
        goBackLinkText="Back to providers"
        goBackLinkUrl={"/settings/providers"}
      >
        <WithAuth requiredGroups={PermissionGroups.providers.write}>
          <PrimaryButton type="button" handleClick={() => dispatch(toggleEditSidebar())}>
            <PlusIcon /> Add new configuration
          </PrimaryButton>
        </WithAuth>
      </PageHeader>
      {!externalPriceConfigId && <CreateExternalPriceConfig refetch={refetch} />}
      {externalPriceConfigId && (
        <EditExternalPriceConfig
          externalPriceConfigId={externalPriceConfigId}
          setExternalPriceConfigId={setExternalPriceConfigId}
          refetch={refetch}
        />
      )}
      <ExternalPriceConfigTable
        externalPriceConfigurations={externalPriceProviders}
        error={error}
        setExternalPriceConfigId={setExternalPriceConfigId}
        loading={loading}
      />
    </Container>
  )
}
